import ReactSelect from 'react-select'

import { zIndex } from '../../constants'

const getBorderStyles = (state) => {
  if (state.isFocused) return '0.2rem solid var(--primary-color) !important'
  if (state.selectProps.error) return '0.2rem solid var(--alert-color) !important'
  return '0.2rem solid var(--secondary-input-bg) !important'
}

const customStyles = {
  control: (base, state) => ({
    ...base,
    border: getBorderStyles(state),
  }),
}

export default function Select({ ...selectProps }) {
  return (
    <>
      <ReactSelect
        classNamePrefix='react-select'
        styles={{ ...customStyles, ...(selectProps.styles || {}) }}
        theme={(theme) => ({
          ...theme,
          colors: { ...theme.colors, primary: 'var(--primary-color)' },
          ...(selectProps.theme || {}),
        })}
        {...selectProps}
      />

      <style jsx>{`
        :global(.react-select__control) {
          width: 100% !important;
          height: 4.2rem !important;
          box-shadow: none !important;
          border-radius: 2.1rem !important;
          font-size: 1.6rem !important;

          &:hover {
            cursor: text !important;
          }
        }

        :global(.react-select__indicator-separator) {
          display: none !important;
        }

        :global(.react-select__option) {
          font-size: 1.6rem !important;
          color: var(--primary-bg-color) !important;
        }

        :global(.react-select__menu) {
          overflow: hidden !important;
          border-radius: 2.1rem !important;
        }

        :global(.react-select__value-container) {
          padding: 0.2rem 1.5rem !important;
        }

        :global(.react-select__placeholder) {
          color: var(--secondary-text-color) !important;
        }

        :global(.react-select__control--is-disabled) {
          background-color: var(--secondary-input-bg) !important;
        }

        :global(.react-select__single-value--is-disabled) {
          color: var(--secondary-text-color) !important;
        }

        @media (max-width: 1024px) {
          :global(.react-select__control) {
            min-height: 3.5rem !important;
            height: 3.5rem !important;
            border-radius: 1.8rem !important;
            font-size: 1.4rem !important;
          }

          :global(.react-select__option) {
            font-size: 1.4rem !important;
          }

          :global(.react-select__indicators) {
            height: 100% !important;
          }

          :global(.react-select__menu) {
            overflow: hidden !important;
            border-radius: 1.8rem !important;
          }
        }
      `}</style>

      <style jsx>{`
        :global(.react-select__menu) {
          z-index: ${zIndex.Modal} !important;
        }
      `}</style>
    </>
  )
}
